import loadable from '@loadable/component';
import Loading from '../components/Loader';
import { fetchJob, fetchJobConnections } from '../actions/job';
import { fetchFeedback, fetchHipagesFeedback } from '../actions/feedback';

const Feedback = loadable(
  () => import(/* webpackChunkName: "feedback" */ '../containers/Feedback'),
  { fallback: Loading }
);

Feedback.needs = (props, { dispatch }) => {
  Feedback.preload();
  const job = dispatch(fetchJob(props.params.job));
  const connections = dispatch(fetchJobConnections(props.params.job));
  const feedback = dispatch(fetchFeedback(props.params.job));
  const hipagesFeedback = dispatch(fetchHipagesFeedback(props.params.job));

  return Promise.all([job, connections, feedback, hipagesFeedback]);
};

export default Feedback;
